module.exports = __webpack_public_path__ + "dbff6a4f2e880a0a993993c03314d18f.pdf";